import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { User } from '@app/_models';
import { AuthenticationService, AlertService } from '@app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ReservationService } from '@app/_components/reservation';
import { Table } from 'primeng/table';
import { Location } from '@angular/common';
import {
	MatDialog,
	MatDialogConfig,
	MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ConstantService } from '@app/_services/constant.service';
import * as moment from 'moment';
import { ReservationComponent } from '../reservation/reservation.component';
import { ReservationContainerComponent } from '../reservation/reservation-container/reservation-container.component';
import { OrderComponent } from '@app/_components/order/order/order.component';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PropertyService } from '@app/_components/property/property.service';
import { ReservationCreateComponent } from '../reservation-create/reservation-create.component';
import { ReservationAdvanceSearchComponent } from '../reservation-advance-search/reservation-advance-search.component';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';
import {CompareReservationLedgerService} from '@app/_components/compare-reservation-ledger/compare-reservation-ledger.service';
import {OrderDetailListComponent} from '@app/_components/reservation/components/reservation/order-detail/order-detail-list/order-detail-list.component';
import {ReservationLedgerListComponent} from '@app/_components/reservation/components/reservation-ledger/reservation-ledger-list/reservation-ledger-list.component';
import {ReportService} from '@app/_components/report';

@Component({
    selector: 'app-reservation-ledger-summary',
    templateUrl: './reservation-ledger-summary.component.html',
    styleUrls: ['./reservation-ledger-summary.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    standalone: false
})
export class ReservationLedgerSummaryComponent implements OnInit {

  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;

	datasource: any[];
	reservation: User;
	reservations: any[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];
	advanceSearchData: any = [];
	advanceSearchDataFilter: LazyLoadEvent = {};
	eventFilter: LazyLoadEvent = {};

	// For reservation list to be shown on dialog
	formTitle: String;
	reservationForPredicate: any;
	showCreateReservationPopUp = false;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;

	statuses: any;

	referralSources: any[];
	properties: any[] = [];
	numAdults: any[];
	searchName: any;
	searchData: { [k: string]: any; };
	activatedRoutePropertyCode: any;
  shortTermRentals: any;
  minDate: any = new Date();



	constructor(
    private compareReservationLedgerService: CompareReservationLedgerService,
    public authenticationService: AuthenticationService,
		public reservationService: ReservationService,
		public alertService: AlertService,
		public constantService: ConstantService,
    private reportService: ReportService,
    private messageService: MessageService,
		private formBuilder: UntypedFormBuilder,
		public router: Router,
		private _activatedRoute: ActivatedRoute,
		private propertyService: PropertyService,
		private location1: Location,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any
	) {
		this.formTitle = data.title,
			this.reservationForPredicate = data.reservation;
		this.referralSources = this.reservationService.referralSources;
		this.numAdults = this.reservationService.numAdults;
	}

  ngOnInit(): void {
    this.formBuild();
    this.loadShortTermRentals();
  }
  formBuild() {
    this.form1 = this.formBuilder.group({
      shortTermRentalIds: [],
      startDate: [],
      endDate: [],
      globalFilter : []
    });
  }
  onDateChange()
  {
    if (this.form1.get('startDate').value) {
      this.minDate = this.form1.get('startDate').value;
    }
  }
  loadShortTermRentals() {
    this.loading = true;
    this.reportService.propertySummaryList().pipe().subscribe(

      data => {
        this.shortTermRentals = data.data.propertySummaryList;
      },
      error => {
        console.log('reports LIST!: ' + JSON.stringify(error));
        this.loading = false;
      },
      () => { this.loading = false; }
    );
  }

  search(){
    this.advanceSearchDataFilter.filters = {};
    if (this.form1.value && this.form1.value.startDate && this.form1.value.endDate) {
      this.advanceSearchDataFilter.filters['startDate'] = {'value': moment(this.form1.get('startDate').value).format('MM/DD/YYYY'), 'matchMode': 'in'};
      this.advanceSearchDataFilter.filters['endDate'] = {'value': moment(this.form1.get('endDate').value).format('MM/DD/YYYY'), 'matchMode': 'in'};
      if (this.form1.value.shortTermRentalIds) {
        let shortTermRentalIdList: Array<any> = [];
        this.form1.value.shortTermRentalIds.forEach(element => {
          shortTermRentalIdList.push(element.shortTermRentalId);
        });
          this.advanceSearchDataFilter.filters['reservationVO.shortTermRentalVO.shortTermRentalId'] = {'value': shortTermRentalIdList, 'matchMode': 'in'};
      }
    }else{
      this.advanceSearchDataFilter.filters = {};
    }
    this.loadLazy(this.lazyLoadEvent);
  }

  loadLazy(event: LazyLoadEvent) {
		try {
      this.lazyLoadEvent = event;

			if (event.filters && Object.keys(event.filters).length > 0)
			{
				this.eventFilter = event.filters;
			}
			if (this.advanceSearchDataFilter.filters && Object.keys(this.advanceSearchDataFilter.filters).length > 0)
			{
				// combine objects
				event.filters = { ...event.filters, ...this.advanceSearchDataFilter.filters };
			}
			this.loading = true;
			this.lazyLoadEvent = event;
			console.log('EVENT ' + JSON.stringify(event));
			console.log(

				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);
			// https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
			// if we are filtering by some field (ie property) (event.filters are not empty {})
			if (Object.keys(event.filters).length > 0) {
				console.log('FILTERS!');
				// if there are no other sorts, initialize the event.multiSortMeta
				if (!event.multiSortMeta) {
					event.multiSortMeta = [];
          event.multiSortMeta.push({ field: 'createDate', order: -1 });
				}
			}
			else {
				// sort by createDate
				console.log('NO MULTI!');
				if (!event.multiSortMeta) {
					event.multiSortMeta = [];
				}
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}


			if (event.filters?.checkInDateTime) {
				event.filters.checkInDateTime.value = moment(event.filters.checkInDateTime.value).format('MM/DD/YYYY');
			}

			if (event.filters?.checkOutDateTime) {
				event.filters.checkOutDateTime.value = moment(event.filters.checkOutDateTime.value).format('MM/DD/YYYY');
			}


			if (this.activatedRoutePropertyCode)
			{
				// show only activities that are assigned to this activityFeeId
				let rateBucketIdFilter = { 'shortTermRentalVO.propertyCode': { 'value': this.activatedRoutePropertyCode, 'matchMode': 'in' } };
				Object.assign(event.filters, rateBucketIdFilter);
			}
			if (event.filters?.global) {
				event.filters.global.value = event.filters.global.value.trim();
				this.searchName = event.filters.global.value.trim();
			}
			if (event.globalFilter == null && this.searchName != null && this.searchName != '') {
				event.filters.global = {
					matchMode: 'contains',
					value: this.searchName
				};
				event.globalFilter = this.searchName;
			}

      let filters = {...event.filters};
      if (filters?.locked?.value == null){
          delete filters.locked;
      }
      if (filters?.balanced?.value == null){
        delete filters.balanced;
      }
      if (this.form1.value.globalFilter == ''){
        delete filters.global;
        delete filters.filter;
      }
			const pageNumber = Math.round(event.first / event.rows);
			this.reservationService.findByReservationLedgerSummaryListFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
        filters).pipe(first()).subscribe(

					res => {
						// console.log('reservations are: ' + JSON.stringify(apiResponse));
						this.datasource = res.data.reservations;
						this.recordTotal = res.page.recordTotal;
						this.reservations = res.data.reservations;
					},
					error => {
						console.log('USER LIST!: ' + JSON.stringify(error));
						this.alertService.error(error);
						this.loading = false;
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.reservations = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
  getSyncColor(reservation: any){
    if (reservation.balanced){

      return 'rgba(0,128,0,0.35)';
    }
    return 'rgba(243,0,0,0.34)';

  }

  getDiscripancyAmt(reservation: any){
    if (!reservation.balanced){
      let amt = reservation.invoiceOriginalTotal + (reservation.ledgerCreditTotal * -1);
      return amt;
    }
    return reservation?.ledgerTotal;

  }

  refresh(){
    this.loadLazy(this.lazyLoadEvent);
  }
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  generateLedgers(reservation: any) {
    this.compareReservationLedgerService.generateLedgers(reservation?.reservationId).subscribe(
      res => {
        this.alertService.success('Generate Ledger successfully for reservation#' + reservation?.reservationId);
        this.refresh();

      },
      err => {
        console.log('Feature-Update FAIL: ' + JSON.stringify(err));
        this.alertService.error(err);
      },
      () => {
        this.loading = false;
      });
  }

  openOrder(reservation: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "100vw";
    dialogConfig.width = "95vw";
    dialogConfig.maxHeight = "50vw";
    dialogConfig.height = "95vh";
    dialogConfig.panelClass = "edit-order-mobile";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      reservationId: reservation.reservationId,
      reservation: reservation,
      showCloseButton: true,
      title: 'Edit Order'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(OrderComponent, dialogConfig);
    // this.location1.go('/reservations-edit/' + reservation.reservationId);
    this.location1.go('/reservation-ledger-summary?orderId=' + reservation.orderId);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.searchName = data;

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.updateReservationCB(data);
        this.loadLazy(this.lazyLoadEvent);

        // close the dialogBox
        dialogRef.close();
      });

    // dialogRef.componentInstance.doDelete.subscribe(
    // 	data => {
    // 		console.log('Dialog output:', data);

    // 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
    // 		this.deleteReservationCB(data);

    // 		// close the dialogBox
    // 		dialogRef.close();
    // 	});
  }

  openInvoice(reservation: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    // To add new orderDetails, use reservationId, orderId to link FK

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Invoice Reservation#' + reservation.reservationId,

      showPagination: false,
      reservationId: reservation.reservationId,

      checkInDate: reservation.checkInDate,

      checkOutDate: reservation.checkOutDate,
      shortTermRentalId: reservation.shortTermRentalId,
      orderId: reservation.orderId,
      ruReservationId: reservation?.ruReservationId,

    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(OrderDetailListComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {
      this.refresh();

    });
  }
  openLedger(reservation: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = '95vw';
    dialogConfig.width = '95vw';
    dialogConfig.maxHeight = '87vh';
    dialogConfig.height = '87vh';
    

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Reservation Ledgers',
      showFilter: true,
      showPagination: false,
      displayClose: false,
      isPopup: true,
      reservationId: reservation.reservationId

    };
    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ReservationLedgerListComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(() => {
      this.refresh();
    });
    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding

  }
	getResStatusName(resStatus) {
		return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus; }).label;
	}

	getResStatusColor(resStatus) {
		return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus; }).color;
	}
	clear(table: Table) {
		table.clear();
	}
  clearForm(){
    this.formBuild();
  }

	reloadPage() {
		window.location.reload();
	}

  exportSelected(exporttype: any) {
		this.importExportComponent.exporData(exporttype, this.reservations, 'Reservations Info');
		}

    onRowSelect(event) {
      try {
        // use this for adding query params
        // this.router.navigate(['reservation-edit'], { queryParams: { reservationId: event.data.reservationId } });
        // this.router.navigate(['reservations', event.data.reservationId]);
      } catch (error) {
        console.log('onRowSelect(' + event + ')' + error);
      }
    }

}
